import Vue from 'vue';
// import qs from 'query-string';
export class ApiService {
  setAccessToken(accessToken) {
    Vue.axios.defaults.headers.common['Authorization'] = accessToken;
  }
  login(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/login', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  main(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/main', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  signIn(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/signIn', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  emailCheck(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/emailCheck', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateUserProfile(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/updateUserProfile', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  removeUserAccount(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/removeUserAccount', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getUserTask(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/getUserTask', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  signOut(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/signOut', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getUserProfile(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/getUserProfile', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getPlanList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/user/getPlanList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  selectApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/selectApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  insertApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/insertApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/updateApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateApiSchema(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/updateApiSchema', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  selectOneApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/selectOneApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  deleteApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/deleteApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  configSchema(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/configSchema', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  selectApiSchema(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/selectApiSchema', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  deleteApiSchema(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/deleteApiSchema', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  resetAuth(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/resetAuth', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addAuth(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/addAuth', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getApiList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/getApiList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getApiDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/getApiDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getAllApiList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/apis/getAllApiList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  createApp(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/createApp', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appSelect(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appWorkflowList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appWorkflowList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appVersions(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appVersions', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appClone(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appClone', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  appRemove(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/appRemove', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getAppDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/app/getAppDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  connectApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/connect/connectApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  workflowApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/connect/workflowApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  checkApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/connect/checkApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  dropdownApi(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/connect/dropdownApi', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  createWorkflow(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/createWorkflow', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getWorkflowList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getWorkflowList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  deleteWorkflow(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/deleteWorkflow', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateWorkflow(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/updateWorkflow', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getWorkflowDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getWorkflowDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getWorkflowHistory(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getWorkflowHistory', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getWorkflowHistoryDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getWorkflowHistoryDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getApiHistory(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getApiHistory', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  setTemplate(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/setTemplate', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getTemplate(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getTemplate', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  duplicateWorkflow(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/duplicateWorkflow', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateWorkflowRun(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/updateWorkflowRun', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  createGroup(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/createGroup', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getGroupList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/getGroupList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  deleteGroup(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/deleteGroup', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  updateGroup(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workflow/updateGroup', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getConnectionList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workconnection/getConnectionList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addConnection(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workconnection/addConnection', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  deleteConnection(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/workconnection/deleteConnection', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getLeadList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/getLeadList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getLeadDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/getLeadDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  editLead(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/editLead', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  removeLead(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/removeLead', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addLead(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/addLead', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addLeadToList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/addLeadToList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getLeadTracking(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/getLeadTracking', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getLeadsList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/lead/getLeadsList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getListList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/getListList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getListNoPaging(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/getListNoPaging', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/addList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getListDetail(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/getListDetail', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  editList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/editList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  removeList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/removeList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  getListEachLeadList(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/getListEachLeadList', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  addLeadsToLists(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/addLeadsToLists', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
  removeLeadsFromLists(req) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/api/v1/list/removeLeadsFromLists', req).then(res => {
        if (res.status === 200) {
          resolve(res.data);
          return;
        }
        console.error(res.status, res.statusText);
        reject(null);
      })
      .catch((err) => {
        reject(err);
      })
    });
  }
}
const _api = new ApiService();
ApiService.install = function (Vue /* options?: any */) {
  Vue.api = _api;
  Object.defineProperties(Vue.prototype, {
    $api: {
      get() {
        return _api;
      },
    },
    api: {
      get() {
        return _api;
      },
    },
  });
};

Vue.use(ApiService);

export default ApiService;
